import { ActionEligibility } from './types'

const NON_ACTIONABLE_STATUSES = ['changes_requested', 'sent_to_pay', 'reversed', 'draft'] as const

export type NonActionableStatus = (typeof NON_ACTIONABLE_STATUSES)[number]

export const isNonActionableStatus = (status: string): status is NonActionableStatus => {
  return NON_ACTIONABLE_STATUSES.some((nonActionable) => nonActionable === status)
}

export const createEligibilityDefaults = (): ActionEligibility => ({
  canApprove: false,
  canReject: false,
  canReimbursePayroll: false,
  canReimburseSepa: false,
  canSetPaid: false,
  canResetApproval: false,
  canRemovePayroll: false,
  canRevertPaid: false,
  allNonActionable: true,
  eligibleForApproval: [],
  eligibleForRejection: [],
  eligibleForPayroll: [],
  eligibleForSepa: [],
  eligibleForSetPaid: [],
  eligibleForResetApproval: [],
  eligibleForRemovePayroll: [],
  eligibleForRevertPaid: [],
})
